import Section from "../../Section";

export default () => {
  return <Section index={3}></Section>;
};
